import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Lenis from 'lenis'

export const useLenis = () => {
  const lenis = ref(null)
  gsap.registerPlugin(ScrollTrigger)

  onMounted(() => {
    lenis.value = new Lenis()
    lenis.value.on('scroll', ScrollTrigger.update)
    window.lenis = lenis.value
    gsap.ticker.add((time) => {
      lenis.value.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0)
  })

  onUnmounted(() => {
    lenis.value.destroy()
  })

  return { lenis }
}
